export enum BayanEnum {
    All = 'All',
    VERIFIED= 'VERIFIED',
    NOT_VERIFIED = 'NOT_VERIFIED',
  }
  
  
  export enum BayanTypesEnum {
    All = 'All',
    BayanVerified = 'true',
    BayanNotVerified = 'false'
  }